export const CLINIC_FORM_BUTTONS = [
  {
    variant: "contained",
    margin: "1",
    type: "submit",
    title: "Save",
  },
  {
    variant: "outlined",
    margin: "1",
    title: "Reset",
    action:"reset"
  },
];
